import { LoanOfferGenService } from './../services/loan-offer-gen.service';
import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { OwlCarousel } from "ng2-owl-carousel";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ApplyLoanModelPopupComponent } from "app/loan/apply-loan-model-popup/apply-loan-model-popup.component";

@Component({
  selector: 'home-loan-offers',
  templateUrl: './home-loan-offers.component.html',
  styleUrls: ['./home-loan-offers.component.css']
})
export class HomeLoanOffersComponent implements OnInit {
   emptyOfferData=false;
   PortalHodeOffer;
   HideOfferName;
   offername:string='Offer';
  
   @Input() offers;
   @Input() leadType:string;
   @Input() offerdata;
   @Input() inputvalue;

   show_intrest_info=false;
   showSavingsOffer:number = 30;
   public InputFieldValueHomeLoan;

  @ViewChild('owlElement') owlElement: OwlCarousel

  constructor(
    private modalService: NgbModal,
    private loanOfferService:LoanOfferGenService,
  ) {
  
   }

  ngOnInit() {
    let PortalInfoData=localStorage.getItem('portalInfo');
    if(PortalInfoData){
      this.PortalHodeOffer=JSON.parse(PortalInfoData);
      this.HideOfferName=this.PortalHodeOffer.hideoffername;
    }
  
    console.log(this.offerdata);
    if(this.offerdata.length==0){
     this.emptyOfferData=true;
    }else{
    this.emptyOfferData=false;
    }
    //  this.owlElement.refresh();
  }

  ngOnChanges(){
    this.owlElement.refresh();
    this.show_intrest_info=false;
    if(this.offerdata.length>0){
      let offer  = this.offerdata[0];
      if(offer.intrest_1_year){
        this.show_intrest_info=true;
      }
    }
    // if(this.offerdata.intrest_1_year){
    //   this.show_intrest_info=true;
    //   alert(this.show_intrest_info)
    // }
    // this.show_intrest_info=false;
    // if(this.offerdata.length>0){
    //   let offer  = this.offerdata[0];
    //   if(this.offerdata.intrest_1_year){
    //     this.show_intrest_info=true;
    //   }
    // }
  }
 
  
  owl(action){
    switch(action){
      case 'prev':
        this.owlElement.previous();
      break;
      case 'next':
        this.owlElement.next([200]);
      break;
    }
  }

  openThisOffer(offer,lead_type) {
    offer.lead_type = lead_type;
    offer.offer_type = "home_loan_gen";
    console.log(offer);
    localStorage.setItem('lead_offer',JSON.stringify(offer));
    const modalRef = this.modalService.open(ApplyLoanModelPopupComponent,{ size: 'lg',windowClass:'loan-lead-pop-up' });
    modalRef.componentInstance.offer = offer;
    debugger
    modalRef.componentInstance.inputvalue=this.inputvalue;
    modalRef.componentInstance.whtasAppNumber=offer.whatsapp_number;
    modalRef.componentInstance.Messenger=offer.messenger_id;
  }

  showOfferBasedOnSavings(value:number){
    this.showSavingsOffer=value;
  }

}



// WEBPACK FOOTER //
// ./src/app/loan/home-loan-offers/home-loan-offers.component.ts